export default {
    1: {
        h: 72,
        s: 100,
        l: 50,
    },
    2: {
        h: 60,
        s: 100,
        l: 40,
    },
    3: {
        h: 45,
        s: 100,
        l: 40,
    },
    4: {
        h: 30,
        s: 100,
        l: 40,
    },
    5: {
        h: 15,
        s: 100,
        l: 40,
    },
    6: {
        h: 0,
        s: 100,
        l: 40,
    },
    7: {
        h: 0,
        s: 100,
        l: 20,
    },
    8: {
        h: 30,
        s: 100,
        l: 20,
    },
    9: {
        h: 60,
        s: 100,
        l: 20,
    },
    10: {
        h: 80,
        s: 100,
        l: 30,
    },
    11: {
        h: 90,
        s: 100,
        l: 40,
    },
    12: {
        h: 96,
        s: 100,
        l: 50,
    },
    13: {
        h: 120,
        s: 100,
        l: 50,
    },
    14: {
        h: 120,
        s: 100,
        l: 40,
    },
    15: {
        h: 120,
        s: 100,
        l: 30,
    },
    16: {
        h: 120,
        s: 100,
        l: 20,
    },
    17: {
        h: 120,
        s: 100,
        l: 10,
    },
    18: {
        h: 0,
        s: 0,
        l: 0,
    },
    19: {
        h: 75,
        s: 100,
        l: 60,
    },
    20: {
        h: 60,
        s: 60,
        l: 50,
    },
    21: {
        h: 40,
        s: 60,
        l: 50,
    },
    22: {
        h: 20,
        s: 60,
        l: 50,
    },
    23: {
        h: 0,
        s: 60,
        l: 50,
    },
    24: {
        h: 345,
        s: 100,
        l: 40,
    },
    25: {
        h: 330,
        s: 100,
        l: 20,
    },
    26: {
        h: 0,
        s: 33,
        l: 30,
    },
    27: {
        h: 60,
        s: 33,
        l: 30,
    },
    28: {
        h: 90,
        s: 50,
        l: 40,
    },
    29: {
        h: 100,
        s: 60,
        l: 50,
    },
    30: {
        h: 105,
        s: 100,
        l: 60,
    },
    31: {
        h: 132,
        s: 100,
        l: 50,
    },
    32: {
        h: 135,
        s: 100,
        l: 40,
    },
    33: {
        h: 140,
        s: 100,
        l: 30,
    },
    34: {
        h: 150,
        s: 100,
        l: 20,
    },
    35: {
        h: 180,
        s: 100,
        l: 10,
    },
    36: {
        h: 240,
        s: 100,
        l: 10,
    },
    37: {
        h: 80,
        s: 100,
        l: 70,
    },
    38: {
        h: 60,
        s: 50,
        l: 60,
    },
    39: {
        h: 30,
        s: 50,
        l: 60,
    },
    40: {
        h: 0,
        s: 50,
        l: 60,
    },
    41: {
        h: 340,
        s: 60,
        l: 50,
    },
    42: {
        h: 330,
        s: 100,
        l: 40,
    },
    43: {
        h: 300,
        s: 100,
        l: 20,
    },
    44: {
        h: 300,
        s: 33,
        l: 30,
    },
    45: {
        h: 0,
        s: 0,
        l: 40,
    },
    46: {
        h: 120,
        s: 20,
        l: 50,
    },
    47: {
        h: 120,
        s: 50,
        l: 60,
    },
    48: {
        h: 120,
        s: 100,
        l: 70,
    },
    49: {
        h: 144,
        s: 100,
        l: 50,
    },
    50: {
        h: 150,
        s: 100,
        l: 40,
    },
    51: {
        h: 160,
        s: 100,
        l: 30,
    },
    52: {
        h: 180,
        s: 100,
        l: 20,
    },
    53: {
        h: 210,
        s: 100,
        l: 20,
    },
    54: {
        h: 240,
        s: 100,
        l: 20,
    },
    55: {
        h: 90,
        s: 100,
        l: 80,
    },
    56: {
        h: 60,
        s: 33,
        l: 70,
    },
    57: {
        h: 0,
        s: 33,
        l: 70,
    },
    58: {
        h: 330,
        s: 50,
        l: 60,
    },
    59: {
        h: 320,
        s: 60,
        l: 50,
    },
    60: {
        h: 315,
        s: 100,
        l: 40,
    },
    61: {
        h: 280,
        s: 100,
        l: 30,
    },
    62: {
        h: 270,
        s: 50,
        l: 40,
    },
    63: {
        h: 240,
        s: 20,
        l: 50,
    },
    64: {
        h: 180,
        s: 20,
        l: 50,
    },
    65: {
        h: 150,
        s: 50,
        l: 60,
    },
    66: {
        h: 140,
        s: 100,
        l: 70,
    },
    67: {
        h: 156,
        s: 100,
        l: 50,
    },
    68: {
        h: 165,
        s: 100,
        l: 40,
    },
    69: {
        h: 180,
        s: 100,
        l: 30,
    },
    70: {
        h: 200,
        s: 100,
        l: 30,
    },
    71: {
        h: 220,
        s: 100,
        l: 30,
    },
    72: {
        h: 240,
        s: 100,
        l: 30,
    },
    73: {
        h: 120,
        s: 100,
        l: 90,
    },
    74: {
        h: 0,
        s: 0,
        l: 80,
    },
    75: {
        h: 300,
        s: 33,
        l: 70,
    },
    76: {
        h: 300,
        s: 50,
        l: 60,
    },
    77: {
        h: 300,
        s: 60,
        l: 50,
    },
    78: {
        h: 300,
        s: 100,
        l: 40,
    },
    79: {
        h: 270,
        s: 100,
        l: 40,
    },
    80: {
        h: 260,
        s: 60,
        l: 50,
    },
    81: {
        h: 240,
        s: 50,
        l: 60,
    },
    82: {
        h: 210,
        s: 50,
        l: 60,
    },
    83: {
        h: 180,
        s: 50,
        l: 60,
    },
    84: {
        h: 160,
        s: 100,
        l: 70,
    },
    85: {
        h: 168,
        s: 100,
        l: 50,
    },
    86: {
        h: 180,
        s: 100,
        l: 40,
    },
    87: {
        h: 195,
        s: 100,
        l: 40,
    },
    88: {
        h: 210,
        s: 100,
        l: 40,
    },
    89: {
        h: 225,
        s: 100,
        l: 40,
    },
    90: {
        h: 240,
        s: 100,
        l: 40,
    },
    91: {
        h: 180,
        s: 100,
        l: 90,
    },
    92: {
        h: 240,
        s: 100,
        l: 90,
    },
    93: {
        h: 270,
        s: 100,
        l: 80,
    },
    94: {
        h: 280,
        s: 100,
        l: 70,
    },
    95: {
        h: 285,
        s: 100,
        l: 60,
    },
    96: {
        h: 288,
        s: 100,
        l: 50,
    },
    97: {
        h: 264,
        s: 100,
        l: 50,
    },
    98: {
        h: 255,
        s: 100,
        l: 60,
    },
    99: {
        h: 240,
        s: 100,
        l: 70,
    },
    100: {
        h: 220,
        s: 100,
        l: 70,
    },
    101: {
        h: 200,
        s: 100,
        l: 70,
    },
    102: {
        h: 180,
        s: 100,
        l: 70,
    },
    103: {
        h: 180,
        s: 100,
        l: 50,
    },
    104: {
        h: 192,
        s: 100,
        l: 50,
    },
    105: {
        h: 204,
        s: 100,
        l: 50,
    },
    106: {
        h: 216,
        s: 100,
        l: 50,
    },
    107: {
        h: 228,
        s: 100,
        l: 50,
    },
    108: {
        h: 240,
        s: 100,
        l: 50,
    },
    109: {
        h: 0,
        s: 0,
        l: 100,
    },
    110: {
        h: 300,
        s: 100,
        l: 90,
    },
    111: {
        h: 300,
        s: 100,
        l: 80,
    },
    112: {
        h: 300,
        s: 100,
        l: 70,
    },
    113: {
        h: 300,
        s: 100,
        l: 60,
    },
    114: {
        h: 300,
        s: 100,
        l: 50,
    },
    115: {
        h: 276,
        s: 100,
        l: 50,
    },
    116: {
        h: 270,
        s: 100,
        l: 60,
    },
    117: {
        h: 260,
        s: 100,
        l: 70,
    },
    118: {
        h: 240,
        s: 100,
        l: 80,
    },
    119: {
        h: 210,
        s: 100,
        l: 80,
    },
    120: {
        h: 180,
        s: 100,
        l: 80,
    },
    121: {
        h: 180,
        s: 100,
        l: 60,
    },
    122: {
        h: 195,
        s: 100,
        l: 60,
    },
    123: {
        h: 210,
        s: 100,
        l: 60,
    },
    124: {
        h: 225,
        s: 100,
        l: 60,
    },
    125: {
        h: 240,
        s: 100,
        l: 60,
    },
    126: {
        h: 252,
        s: 100,
        l: 50,
    },
    127: {
        h: 60,
        s: 100,
        l: 90,
    },
    128: {
        h: 0,
        s: 100,
        l: 90,
    },
    129: {
        h: 330,
        s: 100,
        l: 80,
    },
    130: {
        h: 320,
        s: 100,
        l: 70,
    },
    131: {
        h: 315,
        s: 100,
        l: 60,
    },
    132: {
        h: 312,
        s: 100,
        l: 50,
    },
    133: {
        h: 285,
        s: 100,
        l: 40,
    },
    134: {
        h: 280,
        s: 60,
        l: 50,
    },
    135: {
        h: 270,
        s: 50,
        l: 60,
    },
    136: {
        h: 240,
        s: 33,
        l: 70,
    },
    137: {
        h: 180,
        s: 33,
        l: 70,
    },
    138: {
        h: 150,
        s: 100,
        l: 80,
    },
    139: {
        h: 165,
        s: 100,
        l: 60,
    },
    140: {
        h: 180,
        s: 60,
        l: 50,
    },
    141: {
        h: 200,
        s: 60,
        l: 50,
    },
    142: {
        h: 220,
        s: 60,
        l: 50,
    },
    143: {
        h: 240,
        s: 60,
        l: 50,
    },
    144: {
        h: 255,
        s: 100,
        l: 40,
    },
    145: {
        h: 60,
        s: 100,
        l: 80,
    },
    146: {
        h: 30,
        s: 100,
        l: 80,
    },
    147: {
        h: 0,
        s: 100,
        l: 80,
    },
    148: {
        h: 340,
        s: 100,
        l: 70,
    },
    149: {
        h: 330,
        s: 100,
        l: 60,
    },
    150: {
        h: 324,
        s: 100,
        l: 50,
    },
    151: {
        h: 300,
        s: 100,
        l: 30,
    },
    152: {
        h: 300,
        s: 50,
        l: 40,
    },
    153: {
        h: 300,
        s: 20,
        l: 50,
    },
    154: {
        h: 0,
        s: 0,
        l: 60,
    },
    155: {
        h: 120,
        s: 33,
        l: 70,
    },
    156: {
        h: 120,
        s: 100,
        l: 80,
    },
    157: {
        h: 150,
        s: 100,
        l: 60,
    },
    158: {
        h: 160,
        s: 60,
        l: 50,
    },
    159: {
        h: 180,
        s: 50,
        l: 40,
    },
    160: {
        h: 210,
        s: 50,
        l: 40,
    },
    161: {
        h: 240,
        s: 50,
        l: 40,
    },
    162: {
        h: 260,
        s: 100,
        l: 30,
    },
    163: {
        h: 60,
        s: 100,
        l: 70,
    },
    164: {
        h: 40,
        s: 100,
        l: 70,
    },
    165: {
        h: 20,
        s: 100,
        l: 70,
    },
    166: {
        h: 0,
        s: 100,
        l: 70,
    },
    167: {
        h: 345,
        s: 100,
        l: 60,
    },
    168: {
        h: 336,
        s: 100,
        l: 50,
    },
    169: {
        h: 320,
        s: 100,
        l: 30,
    },
    170: {
        h: 330,
        s: 50,
        l: 40,
    },
    171: {
        h: 0,
        s: 20,
        l: 50,
    },
    172: {
        h: 60,
        s: 20,
        l: 50,
    },
    173: {
        h: 90,
        s: 50,
        l: 60,
    },
    174: {
        h: 100,
        s: 100,
        l: 70,
    },
    175: {
        h: 135,
        s: 100,
        l: 60,
    },
    176: {
        h: 140,
        s: 60,
        l: 50,
    },
    177: {
        h: 150,
        s: 50,
        l: 40,
    },
    178: {
        h: 180,
        s: 33,
        l: 30,
    },
    179: {
        h: 240,
        s: 33,
        l: 30,
    },
    180: {
        h: 270,
        s: 100,
        l: 20,
    },
    181: {
        h: 60,
        s: 100,
        l: 60,
    },
    182: {
        h: 45,
        s: 100,
        l: 60,
    },
    183: {
        h: 30,
        s: 100,
        l: 60,
    },
    184: {
        h: 15,
        s: 100,
        l: 60,
    },
    185: {
        h: 0,
        s: 100,
        l: 60,
    },
    186: {
        h: 348,
        s: 100,
        l: 50,
    },
    187: {
        h: 340,
        s: 100,
        l: 30,
    },
    188: {
        h: 0,
        s: 50,
        l: 40,
    },
    189: {
        h: 30,
        s: 50,
        l: 40,
    },
    190: {
        h: 60,
        s: 50,
        l: 40,
    },
    191: {
        h: 80,
        s: 60,
        l: 50,
    },
    192: {
        h: 90,
        s: 100,
        l: 60,
    },
    193: {
        h: 120,
        s: 100,
        l: 60,
    },
    194: {
        h: 120,
        s: 60,
        l: 50,
    },
    195: {
        h: 120,
        s: 50,
        l: 40,
    },
    196: {
        h: 120,
        s: 33,
        l: 30,
    },
    197: {
        h: 0,
        s: 0,
        l: 20,
    },
    198: {
        h: 300,
        s: 100,
        l: 10,
    },
    199: {
        h: 60,
        s: 100,
        l: 50,
    },
    200: {
        h: 48,
        s: 100,
        l: 50,
    },
    201: {
        h: 36,
        s: 100,
        l: 50,
    },
    202: {
        h: 24,
        s: 100,
        l: 50,
    },
    203: {
        h: 12,
        s: 100,
        l: 50,
    },
    204: {
        h: 0,
        s: 100,
        l: 50,
    },
    205: {
        h: 0,
        s: 100,
        l: 30,
    },
    206: {
        h: 20,
        s: 100,
        l: 30,
    },
    207: {
        h: 40,
        s: 100,
        l: 30,
    },
    208: {
        h: 60,
        s: 100,
        l: 30,
    },
    209: {
        h: 75,
        s: 100,
        l: 40,
    },
    210: {
        h: 84,
        s: 100,
        l: 50,
    },
    211: {
        h: 108,
        s: 100,
        l: 50,
    },
    212: {
        h: 105,
        s: 100,
        l: 40,
    },
    213: {
        h: 100,
        s: 100,
        l: 30,
    },
    214: {
        h: 90,
        s: 100,
        l: 20,
    },
    215: {
        h: 60,
        s: 100,
        l: 10,
    },
    216: {
        h: 0,
        s: 100,
        l: 10,
    },
};
